<template>
    <div v-bind:class="['grp_wrap'+classSuffix, addClass, moreClass]" ref="_gripchart">
        <div v-bind:class="['grp_title', addTitleStyle]" v-text="title" v-show="showGrpTitle"></div>
        <div v-bind:class="['grp_stand']" v-show="showGrpStand">
            {{ stand }} <span v-if="typeof source !== 'undefined' && source !== ''">({{ source }})</span>
        </div>
        <div v-bind:class="['grp_unit']" v-text="unit" v-show="showGrpUnit"></div>
        <div v-bind:class="['grp_source']" v-show="showGrpSource"></div>
        <div v-bind:class="[legendClass]" v-html="legend" v-show="isLegend && showGrpLegend"></div>
        <div v-bind:class="['grp_chart']" :style="grpChartStyle">
            <canvas v-if="showCanvas" v-bind:id="'chart-'+chartSeq"></canvas>
        </div>
        <select class="grp_group" v-if="groupList.length > 0"
                v-model="selectedGroupId">
            <option v-for="group in groupList"
                    :value="group.groupById">{{ group.groupName }}</option>
        </select>
    </div>
</template>

<script>
import axios from 'axios'
import 'chartjs-gauge';
import Chart from 'chart.js';
import 'chartjs-chart-treemap';
import { $_WC } from '@/confs/common.const';
import annotationPlugin from "@/libs/grip-chart-annotation";
import ArrowBar from '@/libs/grip.chart.custom.js';

export default {
    /**
     * ver 3.0
     * 방사형 트리맵 추가
     *
     */
    data: function() {
        return {
            title: '',
            stand: '',
            unit: '',
            source: '',
            legend: '',
            isLegend: true,
            viewScale: Math.ceil(window.innerWidth / 1920),
            maxDate: '',
            addClass: [],
            legendClass: 'grp_legend',
            isAnimationOnComplete: false,
            showCanvas: true,
            selectedGroupId: 0,
            groupList: [],
        }
    },
    props: {
        chartid: '',
        classSuffix: {
            type: String,
            default: ''
        },
        moreClass: {
            type: String,
            default: ''
        },
        params: '',
        chartTitle: '',
        chartStand: '',
        chartUnit: '',
        chartSource: '',
        chartKey: '',
        chartTitleSuffix: '',
        showGrpTitle: {
            type: Boolean,
            default: true,
        },
        showGrpStand: {
            type: Boolean,
            default: true,
        },
        showGrpUnit: {
            type: Boolean,
            default: true,
        },
        showGrpSource: {
            type: Boolean,
            default: true,
        },
        showGrpLegend: {
            type: Boolean,
            default: true,
        },
        showGrpValue: {
            type: Boolean,
            default: true,
        },
        grpChartStyle: '',
        fontColor: {
            type: String,
            default: '',
        },
        addTitleStyle: {
            type: String,
            default: '',
        },
        fontMagnification: {
            type: Number,
            default: 1,
        },
        barClkEvt: {
            type: Boolean,
            default: false,
        },
    },
    created: function() {
    },
    computed: {
        chartSeq: function() {
            if(typeof this.chartKey !== 'undefined' && this.chartKey != '') {
                return this.chartKey;
            } else {
                return this.chartid;
            }
        },
    },
    mounted: function() {
        this.getChartjs();
    },
    watch: {
        selectedGroupId: {
            immediate: false,
            handler: function(newVal, oldVal) {
                this.showCanvas = false;
                this.$nextTick(function(){
                    this.showCanvas = true;
                    this.$nextTick(function(){
                        this.getChartjs();
                    }.bind(this));
                }.bind(this));
            }
        },
    },
    methods: {
        getChartjs: function(){
            let vm = this;
            let canvas = document.getElementById("chart-"+vm.chartSeq);
            let ctx = canvas.getContext('2d');

            if(vm.chartid == "") {
                return;
            }

            let chartUrl = $_WC.chartBaseURL + "/" + this.chartid;
            chartUrl += '?groupById=' + vm.selectedGroupId;
            if(typeof this.params !== 'undefined' && this.params != '') {
                chartUrl += '&' + this.params;
            }

            axios.get(chartUrl).then(function(res) {
                if(typeof res.data.multiGroupBy !== 'undefined' && res.data.multiGroupBy !== null) {
                    res.data.multiGroupBy.sort(function (p, c) {
                        return p.groupById - c.groupById;
                    });
                    vm.groupList = res.data.multiGroupBy.filter(function (d) {
                        return d.groupName !== '';
                    });
                }
                vm.setChartjs(ctx, res);
            });
        },
        setChartjs: function(ctx, res){
            let vm = this;
            let conf = res.data.config;
            let date = res.data.maxdate;
            let data = res.data.data;
            if(typeof date.basdtVal !== 'undefined') {
                vm.maxDate = date.basdtVal;
            }

            let proms = [];
            proms.push( vm.setChartConf(conf, data) );
            // Vue.nextTick(function () {
            Promise.all(proms).then(function(){
                data = vm.setChartData(conf, data);
                conf.data.labels = data[conf.data.labelsColumnSeq];

                if(conf.type == "doughnut" || conf.type == "pie") {
                    vm.mappingCircleDatasets(conf, data);
                } else if(conf.type === "radar"){
                    vm.mappingRaderDatasets(conf, data);
                } else if(conf.type === "treemap"){
                    vm.mappingTreemapDatasets(conf, data);
                } else if(conf.type === "gauge") {
                    vm.mappingGaugeDatasets(conf, data);
                } else if(conf.type === 'horizontalBar') {
                    if(typeof conf.isSideDisplay !== 'undefined' && conf.isSideDisplay) {
                        // 좌우표출일 경우 음수처리
                        vm.mappingDatasetsHdminus(conf, data);                                                
                    } else {
                        vm.mappingDatasets(conf, data);                        
                    }
                } else {
                    vm.mappingDatasets(conf, data);                    
                }

                // 기준값(어노테이션 세팅)
                if(typeof conf.options.isUsingAnnotation !== 'undefined') {
                    vm.setChartAnnotation(conf);
                }
                
                var chart = new Chart(ctx, conf);
                vm.legend = chart.generateLegend();

                if(vm.barClkEvt) {
                    let canvas = document.getElementById("chart-"+vm.chartSeq);
                    canvas.onclick = (evt) => {
                        const res = chart.getElementAtEvent(evt);
                        if (res.length === 0) {
                            return;
                        }
                        let selectedVal = chart.data.labels[res[0]._index];
                        vm.$eventBus.$emit("Set::Chart::Param", vm.chartid, selectedVal);
                    };
                }
            });
        },
        unescapeHtml: function(str){
            return str.replaceAll(/&amp;/g, '&')
                .replaceAll(/&lt;/g, '<').replaceAll(/&gt;/g, '>')
                .replaceAll(/&quot;/g, '"').replaceAll(/&#039;/g, "'");
        },
        // 면적 차트 추가
        hexToRgbArray(colorStr, opacity) {
            let el = document.createElement("div");
            el.style["background-color"] = colorStr;
            document.body.appendChild(el);
            let style = window.getComputedStyle(el);
            let color = style["backgroundColor"];
            document.body.removeChild(el);

            let colorArray = color.replace(/rgb\(/, "").replace(/\)/, "").split(",");
            if(typeof opacity !== 'undefined' && !isNaN(opacity)){
                colorArray.push(opacity);
            }
            return colorArray;
        },
        mappingRaderDatasets: function(conf, data){
            let vm = this;
            vm.setNonScalesLabels(conf);
            conf.data.datasets.forEach(function(dataset) {
                dataset.data = data[dataset.dataKdHdngSqno];
            });
        },
        mappingGaugeDatasets: function(conf, data){
            let vm = this;
            let progressPer = 0;
            // vm.setNonScalesLabels(conf);
            conf.data.datasets.forEach(function(dataset) {
                dataset.value = data[dataset.dataKdHdngSqno];
                if(dataset.isPercent) {
                    progressPer = Number(data[dataset.dataKdHdngSqno]) / Number(dataset.progressRange) * 100;
                    dataset.value = [progressPer.toFixed(1)];
                }
            });
            if(conf.data.datasets[0].isProgress) {
                if(typeof conf.data.datasets[0].value !== 'undefined' && conf.data.datasets[0].value !== ''
                        && typeof conf.data.datasets[0].progressRange !== '' ) {
                    let data = [];
                    data.push(conf.data.datasets[0].value[0]);
                    if(conf.data.datasets[0].isPercent) {
                        data.push(100);
                    } else {
                        data.push(conf.data.datasets[0].progressRange);
                    }
                    conf.data.datasets[0].data = data;
                    /*
                    if(conf.data.datasets[0].isPercent) {
                        data = [];
                        data.push(progressPer);
                        data.push(100);
                        conf.data.datasets[0].data = data;
                    }
                    */
                }
                if(typeof conf.data.datasets[0].progressColor !== 'undefined' && conf.data.datasets[0].progressColor !== ''
                        && typeof conf.data.datasets[0].nonProgressColor !== 'undefined' && conf.data.datasets[0].nonProgressColor !== '') {
                    let backgroundColor = [];
                    backgroundColor.push(conf.data.datasets[0].progressColor);
                    backgroundColor.push(conf.data.datasets[0].nonProgressColor);
                    conf.data.datasets[0].backgroundColor = backgroundColor;
                }
                conf.data.datasets[0].labels[0] = '완료';
                conf.data.datasets[0].labels[1] = '미완료';
            }
            // 4k, DID의 경우 폰트 사이즈 조절
            conf.options.valueLabel.fontSize = Chart.defaults.global.defaultFontSize + (6 * vm.viewScale);
            conf.options.valueLabel.padding.top = conf.options.valueLabel.padding.top * vm.viewScale;
            conf.options.valueLabel.padding.bottom = conf.options.valueLabel.padding.bottom * vm.viewScale;
            conf.options.valueLabel.padding.left = conf.options.valueLabel.padding.left * vm.viewScale;
            conf.options.valueLabel.padding.right = conf.options.valueLabel.padding.right * vm.viewScale;
            if(conf.data.datasets[0].isPercent) {
                conf.options.valueLabel.formatter = function(value) {
                    return value + '%';
                }
            }

            if(conf.data.labelsColumnSeq !== "-1") {
                // 컬러 투명도 설정
                conf.data.datasets[0].backgroundColor.forEach(function(c, index) {
                    let rgbArray = vm.hexToRgbArray(c, 0.9);
                    conf.data.datasets[0].hoverBackgroundColor.push(c);
                    conf.data.datasets[0].backgroundColor[index] = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';
                });
            }
            if(typeof conf.options.needleColor !== 'undefined' && conf.options.needleColor.trim() !== '') {
                let rgbArray = vm.hexToRgbArray(conf.options.needleColor, 1);
                conf.options.needle.color = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';
            }
        },
        mappingTreemapDatasets: function(conf, data){
            let vm = this;
            vm.setNonScalesLabels(conf);
            let tree = [];
            let dataset = conf.data.datasets[0];
            data[conf.data.labelsColumnSeq].forEach(function(label, index){
                tree.push({label: label, value: data[dataset.dataKdHdngSqno][index]});
            });

            if(dataset.useMultiBackgroundColor){
                let tmpHoverBg = [];
                let tmpBg = [];
                tree.forEach(function(t, i){
                    let rgbArray = vm.hexToRgbArray(dataset.multiBackgroundColors[i], 0.9);
                    tmpHoverBg.push(dataset.multiBackgroundColors[i]);
                    tmpBg.push('rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')');
                });
                conf.data.datasets[0].hoverBackgroundColor = tmpHoverBg;
                conf.data.datasets[0].backgroundColor = tmpBg;
            } else {
                if(conf.data.labelsColumnSeq !== "-1") {
                    // 컬러 투명도 설정
                    let rgbArray = vm.hexToRgbArray(conf.data.datasets[0].backgroundColor, 0.9);
                    conf.data.datasets[0].hoverBackgroundColor = conf.data.datasets[0].backgroundColor;
                    conf.data.datasets[0].backgroundColor = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';
                } else {
                    conf.data.datasets[0].hoverBackgroundColor = [];
                    conf.data.datasets[0].backgroundColor.forEach(function(backgroundColor, i){
                        let rgbArray = vm.hexToRgbArray(backgroundColor, 0.9);
                        conf.data.datasets[0].hoverBackgroundColor.push(backgroundColor);
                        conf.data.datasets[0].backgroundColor[i] = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';
                    });
                }
            }
            dataset.tree = tree;
        },
        mappingCircleDatasets: function(conf, data){
            let vm = this;
            conf.data.datasets.forEach(function(dataset) {
                if(typeof conf.options.isHalf !== 'undefined') {
	                if(conf.options.isHalf) {
    	                conf.options.rotation = -Math.PI;
    	                conf.options.circumference = Math.PI;	                    	                
	                }
	            }
                if(Array.isArray(dataset.dataKdHdngSqno)) {
                    var datas = [];
                    dataset.dataKdHdngSqno.forEach(function(sqno){
                        data[sqno].forEach(function(data){
                            datas.push(data);
                        });
                    });
                    dataset.data = datas;
                    if(Array.isArray(dataset.label)) {
                        if(dataset.label.length > 1) {
                            conf.data.labels = dataset.label;
                        } else {
                            dataset.label = conf.data.labels;
                        }
                    }
                } else {
                    dataset.data = data[dataset.dataKdHdngSqno];
                    dataset.label = conf.data.labels;
                }
            });
        },
        mappingDatasets: function(conf, data){
        	let vm = this;
        	if(typeof conf.options.isLegendParam !== 'undefined' && conf.options.isLegendParam) {
        	    let paramList = [];
        	    let pList = vm.params.split('&');
                if(!!pList) {
                    pList.forEach(function(d) {
                        if(typeof d.split('=')[1] !== 'undefined') {
                            if(d.split('=')[1].indexOf(',') > 1) {
                                let subDoList = d.split('=')[1].split(',');
                                paramList = paramList.concat(subDoList);
                            } else {
                                paramList.push(d.split('=')[1]);
                            }
                        }
                    });
                    conf.data.datasets = conf.data.datasets.filter(function(dataset, idx) {
                        let label = dataset.label;
                        if(paramList.includes(label)) {
                            dataset.data = vm.setDatasets(dataset, data[dataset.dataKdHdngSqno]);
                            return true;
                        }
                    });                
                }
        	} else {
            	conf.data.datasets.forEach(function(dataset, idx) {
            	    dataset.data = vm.setDatasets(dataset, data[dataset.dataKdHdngSqno]);
            	});        	    
        	}
        },
        mappingDatasetsHdminus: function(conf, data){
            let vm = this;
            conf.data.datasets.forEach(function(dataset, idx) {
                if(idx == 0) {
                    dataset.data = vm.setDatasetsMinus(dataset, data[dataset.dataKdHdngSqno]);                      
                } else {
                    dataset.data = vm.setDatasets(dataset, data[dataset.dataKdHdngSqno]);                       
                }
            });
        },
        setChartAnnotation: function(conf) {
            let vm = this;
            if(!conf.options.isUsingAnnotation) {
                if(typeof conf.options.annotation !== 'undefined') {
                    conf.options.annotation = {};
                }
            } else {
                if(typeof conf.options.annotation !== 'undefined') {
                    // line
                    if(typeof conf.options.annotation.annotations !== 'undefined') {
                        conf.options.annotation.annotations.forEach(function(d) {
                            d.borderWidth = Number(d.borderWidth) * vm.viewScale;
                            let borderArr = vm.hexToRgbArray(d.borderColor, Number(d.borderOpacity));
                            if(borderArr.length === 4){
                                d.borderColor = 'rgba(' + borderArr[0] + ',' + borderArr[1] + ',' + borderArr[2] + ',' + borderArr[3] + ')';        
                            } else if(borderArr.length === 3){
                                d.borderColor = 'rgba(' + borderArr[0] + ',' + borderArr[1] + ',' + borderArr[2] + ')';
                            }
                            if(d.type == 'line') {
                                if(typeof d.showLabel !== 'undefined') {
                                    d.label.enabled = d.showLabel;                                                                        
                                } else {
                                    d.label.enabled = conf.options.isUsingLabel;                                    
                                }
                                d.label.fontSize = d.label.fontSize * vm.viewScale;
                                if(d.label.enabled) {
                                    let  backgroundColorArr = vm.hexToRgbArray(d.label.backgroundColor, Number(d.label.backgroundOpacity));
                                    if(backgroundColorArr.length === 4){
                                        d.label.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ',' + backgroundColorArr[3] + ')';        
                                    } else if(borderArr.length === 3){
                                        d.label.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ')';
                                    }
                                }
                            }
                            if(d.type == 'box') {
                                if(typeof d.showLabel !== 'undefined') {
                                    d.label.enabled = d.showLabel;                                                                        
                                } else {
                                    d.label.enabled = conf.options.isUsingLabel;                                    
                                }
                                d.label.fontSize = d.label.fontSize * vm.viewScale;
                                if(d.label.enabled) {
                                    let  backgroundColorArr = vm.hexToRgbArray(d.label.backgroundColor, Number(d.label.backgroundOpacity));
                                    if(backgroundColorArr.length === 4){
                                        d.label.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ',' + backgroundColorArr[3] + ')';        
                                    } else if(borderArr.length === 3){
                                        d.label.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ')';
                                    }
                                }
                                
                                let backgroundColorArr = vm.hexToRgbArray(d.backgroundColor, d.backgroundOpacity);
                                if(backgroundColorArr.length === 4){
                                    d.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ',' + backgroundColorArr[3] + ')';        
                                } else if(borderArr.length === 3){
                                    d.backgroundColor = 'rgba(' + backgroundColorArr[0] + ',' + backgroundColorArr[1] + ',' + backgroundColorArr[2] + ')';
                                }
                                
                                if(conf.type == "horizontalBar") {
                                    if(typeof d.xMinSeq !== 'undefined' && d.xMinSeq !== '' && 
                                            typeof d.xMaxSeq !== 'undefined' && d.xMaxSeq !== '') {
                                        let minSeq = Number(d.xMinSeq) - 1;
                                        let maxSeq = Number(d.xMaxSeq) - 1;
                                        d.yMin = conf.data.labels[minSeq];
                                        d.yMax = conf.data.labels[maxSeq];                                    
                                    } else {
                                        d.yMin = "";
                                        d.yMax = "";
                                    }                                    
                                } else {
                                    if(typeof d.xMinSeq !== 'undefined' && d.xMinSeq !== '' && 
                                            typeof d.xMaxSeq !== 'undefined' && d.xMaxSeq !== '') {
                                        let minSeq = Number(d.xMinSeq) - 1;
                                        let maxSeq = Number(d.xMaxSeq) - 1;
                                        d.xMin = conf.data.labels[minSeq];
                                        d.xMax = conf.data.labels[maxSeq];                                    
                                    } else {
                                        d.xMin = "";
                                        d.xMax = "";
                                    }
                                }
                                
                            }
                        });
                    }
                }
            }
        },
        setChartData: function(conf, data) {
            let vm = this;

            if(conf.data.datasets.length > 0){
                conf.data.datasets.forEach(function(d,i){
                    if(typeof d.label !== 'undefined' && d.label !== ''){
                        conf.data.datasets[i].label = d.label.replace('&amp;middot;', '·');
                    }
                });
            }

            // 면적 차트 추가
            conf.data.datasets.forEach(function(d,i){
                if(typeof d.fill !== 'undefined' && d.fill === true){
                    if(typeof d.fillOpacity !== 'undefined' && !isNaN(d.fillOpacity)){
                        let rgbArray = vm.hexToRgbArray(d.backgroundColor, d.fillOpacity);
                        if(rgbArray.length === 4){
                            d.backgroundColor = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ',' + rgbArray[3] + ')';
                        } else if(rgbArray.length === 3){
                            d.backgroundColor = 'rgba(' + rgbArray[0] + ',' + rgbArray[1] + ',' + rgbArray[2] + ')';
                        }
                    }
                }
            });

            conf.data.datasets.forEach(function(dataset, i){
                if(dataset.type === 'line' && vm.viewScale > 1) {
                    dataset.borderWidth = Number(dataset.borderWidth) * 2;
                    // dataset.pointBorderWidth 점 크기는 설정 안하면 자동으로 같아짐
                }
            });

            // 연산 기능은 정럴 이전으로 변경
            let mixDataKdHdngSqnos = [];
            conf.data.datasets.forEach(function(dataset, i){
                // 필드 연산 추가
                if(typeof dataset.mixDataKdHdng !== 'undefined' && dataset.mixDataKdHdng.length > 0) {
                    let mixDataKdHdngSqno = dataset.dataKdHdngSqno;
                    let mixDataVal = [];
                    dataset.mixDataKdHdng.forEach(function(mixData, mixIndex){
                        data[dataset.dataKdHdngSqno].forEach(function(v, index){
                            if(typeof mixDataVal[index] === 'undefined') {
                                mixDataVal[index] = 0;
                            }
                            if(mixIndex === 0) {
                                var oldVal = parseFloat(data[dataset.dataKdHdngSqno][index]);
                            } else {
                                var oldVal = mixDataVal[index];
                            }

                            if(mixData.dataKdHdngSqno === 'input') {
                                // 입력 값으로 연산
                                var newVal = parseFloat(mixData.inputValue);

                            } else {
                                // 필드 값으로 연산
                                var newVal = parseFloat(data[mixData.dataKdHdngSqno][index]);
                            }
                            if(isNaN(oldVal)) {
                                oldVal = 0;
                            }
                            if(isNaN(newVal)) {
                                newVal = 0;
                            }
                            switch(mixData.operator) {
                                case "+" :
                                    mixDataVal[index] = oldVal + newVal;
                                    break;
                                case "-" :
                                    mixDataVal[index] = oldVal - newVal;
                                    break;
                                case "*" :
                                    mixDataVal[index] = oldVal * newVal;
                                    break;
                                case "/" :
                                    mixDataVal[index] = oldVal / newVal;
                                    break;
                            }
                        });
                    });

                    let newSqno = mixDataKdHdngSqno + '_mix';
                    if(typeof data[newSqno] === 'undefined') {
                        data[newSqno] = mixDataVal;
                        conf.data.datasets.forEach(function(d){
                            if(d.dataKdHdngSqno === mixDataKdHdngSqno && d.mixDataKdHdng.length > 0) {
                                d.dataKdHdngSqno = newSqno;
                                mixDataKdHdngSqnos.push(newSqno);
                            }
                        });
                    }
                }
            });

            // 백분율 추가
            if(conf.type == "doughnut" || conf.type == "pie") {
                if(typeof data['-2'] !== 'undefined') {
                    let totalVal = 0;
                    if(mixDataKdHdngSqnos.length > 0){
                        mixDataKdHdngSqnos.forEach(function(key){
                            data[key].forEach(function (d) {
                                totalVal += Number(d);
                            });
                        });
                    } else {
                        for (let key in data) {
                            if (Number(key) > 0) {
                                data[key].forEach(function (d) {
                                    totalVal += Number(d);
                                });
                            }
                        }
                    }
                    let goalValue = 100;
                    if(typeof conf.options.goalValue !== 'undefined' && !isNaN(conf.options.goalValue)) {
                        goalValue = Number(conf.options.goalValue);
                    }
                    data['-2'].push(goalValue - totalVal);
                }
            }

            // 코드형식 코드순서 정렬기능 추가
            if(typeof conf.options.codeSort !== 'undefined' && conf.options.codeSort === true) {
                if(typeof data['-9999'] !== 'undefined') {
                    let sortData = {};
                    for(let key in data) {
                        if(key !== '-9999') {
                            let sortList = [];
                            if(typeof sortList[key] === 'undefined') {
                                sortList[key] = [];
                            }
                            for(var i = 0; i < data[key].length; i++) {
                                var sortMap = {
                                    data: data[key][i],
                                    seq: Number(data['-9999'][i]),
                                };
                                sortList[key].push(sortMap);
                            }
                            for(key in sortList) {
                                sortList[key].sort(function(pre, cur){
                                    return Number(pre.seq) > Number(cur.seq) ? 1 : Number(pre.seq) < Number(cur.seq) ? -1: 0;
                                });
                                if(typeof sortData[key] === 'undefined') {
                                    sortData[key] = [];
                                }
                                sortList[key].forEach(function(d){
                                    sortData[key].push(d.data);
                                });
                            }
                        }
                    }
                    data = sortData;
                }
            }

            // 높은 값 정렬
            if(typeof conf.options.upperSort !== "undefined" && conf.options.upperSort == true) {
                var axesSeq = conf.data.labelsColumnSeq;
                var sumList = [];
                for(let key in data) {
                    if(key == axesSeq || key == -9999) {
                        continue;
                    }

                    for(let i = 0; i < data[key].length; i++) {
                        if(typeof sumList[i] === "undefined") {
                            sumList[i] = {};
                            sumList[i].key = i;
                            sumList[i].value = 0;
                        }
                        var val = parseFloat(data[key][i]);
                        if(isNaN(val)) {
                            val = 0;
                        }
                        sumList[i].value += val;
                    }
                }
                sumList.sort(function(pre, cur){
                    return parseFloat(pre.value) > parseFloat(cur.value) ? -1 : parseFloat(pre.value) < parseFloat(cur.value) ? 1: 0;
                });

                var sortData = {};
                for(let key in data) {
                    sumList.forEach(function(v){
                        if(typeof sortData[key] === "undefined") {
                            sortData[key] = [];
                        }
                        sortData[key].push(data[key][v.key]);
                    });
                }
                data = sortData;
            }

            // 역순정렬 - 항상 최상위
            if(typeof conf.options.reverse !== "undefined") {
                if(conf.options.reverse == true) {
                    for(let d in data) {
                        data[d].reverse();
                    }
                }
            }

            // 사용자 정렬 추가
            if(typeof conf.options.customSort !== "undefined" && conf.options.customSort !== '') {
                let customLabelsColumnSeq = conf.data.labelsColumnSeq;
                let tmpCustomSort = conf.options.customSort.split(':');
                let customSortKeys = [];
                tmpCustomSort.forEach(function(d, idx){
                    data[customLabelsColumnSeq].forEach(function(d2, idx2){
                        if(d === d2){
                            customSortKeys.push(idx2);
                        }
                    });
                });

                if(customSortKeys.length > 0){
                    let customSortData = {};
                    for(let key in data) {
                        if(typeof customSortData[key] === "undefined") {
                            customSortData[key] = [];
                        }
                        customSortKeys.forEach(function(seq){
                            customSortData[key].push(data[key][seq]);
                        });
                    }
                    data = customSortData;
                }
            }

            // start: 평균선
            if(conf.data.datasets.length > 0){
                let sumDataMap = {};
                let avgDataMap = {};
                let avgDatasets = [];
                conf.data.datasets.forEach(function(dataset){
                    if(typeof dataset.showAvgLine !== 'undefined' && dataset.showAvgLine){
                        if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq && Number(dataset.dataKdHdngSqno) > -9999){
                            let avgSqno = dataset.dataKdHdngSqno + '_avg';
                            data[dataset.dataKdHdngSqno].forEach(function(d, index){
                                if(typeof sumDataMap[dataset.dataKdHdngSqno] === 'undefined'){
                                    sumDataMap[dataset.dataKdHdngSqno] = 0;
                                }
                                if(!isNaN(d)){
                                    sumDataMap[dataset.dataKdHdngSqno] += Number(d);
                                }
                            });
                            avgDataMap[dataset.dataKdHdngSqno] = sumDataMap[dataset.dataKdHdngSqno] / data[dataset.dataKdHdngSqno].length;

                            data[dataset.dataKdHdngSqno].forEach(function(d, i){
                                if(typeof data[avgSqno] === 'undefined'){
                                    data[avgSqno] = [];
                                }
                                data[avgSqno][i] = avgDataMap[dataset.dataKdHdngSqno];
                            });

                            avgDatasets.push({
                                dataKdHdngSqno: avgSqno,
                                type: 'line',
                                label: dataset.label + ' 평균선',
                                data: [],
                                borderDash: [10, 5],
                                fill: false,
                                fillOpacity: '',
                                borderWidth: 2,
                                backgroundColor: dataset.showAvgLineColor,
                                borderColor: dataset.showAvgLineColor,
                                showValue:{
                                    display: false,
                                    textColor: '#ffffff'
                                },
                                digitFixed: dataset.digitFixed,
                                accumulate: false,
                                mixDataKdHdng: [],
                                showValueType: '',
                                showValueText: '',
                                valuePosition: 'top',
                                replaceColorType: '',
                                replaceColorValue: '',
                                replaceColor: '#ffffff',
                                hidden: false,
                                customPointRadius: false,
                                fieldGroupTp: '',
                                showValueVal: true,
                                showValuePercent: false,
                                showValuePercentSum: false,
                                pointRadius: 0,
                            });
                        }
                    }
                });
                if(avgDatasets.length > 0){
                    avgDatasets.reverse();
                    avgDatasets.forEach(function(avgDataset){
                        conf.data.datasets.unshift(avgDataset);
                    });
                }
            }
            // end: 평균선

            // start: 추세선
            if(conf.data.datasets.length > 0){
                let trendDataMap = {};
                let trendDatasets = [];
                conf.data.datasets.forEach(function(dataset){
                    if(typeof dataset.showTrdLine !== 'undefined' && dataset.showTrdLine){
                        if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq && Number(dataset.dataKdHdngSqno) > -9999){
                            let trendSqno = dataset.dataKdHdngSqno + '_trend';
                            trendDataMap[trendSqno] = [];
                            let y = [];
                            let x = [];
                            data[dataset.dataKdHdngSqno].forEach(function(d, index){
                                y.push(Number(d));
                                x.push(index + 1);
                            });
                            let [b, a] = vm.logest(x, y);
                            for (let i = 0; i < x.length; i++) {
                                trendDataMap[trendSqno].push((b * Math.log(x[i]) + a));
                            }
                            for(let trendSqno in trendDataMap){
                                data[trendSqno] = trendDataMap[trendSqno];
                            }
                            trendDatasets.push({
                                dataKdHdngSqno: trendSqno,
                                type: 'line',
                                label: dataset.label + ' 추세선',
                                data: [],
                                tension: 0.3,
                                borderDash: [5, 5],
                                fill: false,
                                fillOpacity: '',
                                borderWidth: 2,
                                backgroundColor: dataset.showTrdLineColor,
                                borderColor: dataset.showTrdLineColor,
                                showValue:{
                                    display: false,
                                    textColor: '#ffffff'
                                },
                                digitFixed: dataset.digitFixed,
                                accumulate: false,
                                mixDataKdHdng: [],
                                showValueType: '',
                                showValueText: '',
                                valuePosition: 'top',
                                replaceColorType: '',
                                replaceColorValue: '',
                                replaceColor: '#ffffff',
                                hidden: false,
                                customPointRadius: false,
                                fieldGroupTp: '',
                                showValueVal: true,
                                showValuePercent: false,
                                showValuePercentSum: false,
                                pointRadius: 0,
                            });
                        }
                    }
                });
                if(trendDatasets.length > 0){
                    trendDatasets.reverse();
                    trendDatasets.forEach(function(trendDataset){
                        conf.data.datasets.unshift(trendDataset);
                    });
                }
            }
            // end: 추세선

            // start: 점선
            if(conf.data.datasets.length > 0) {
                conf.data.datasets.forEach(function(dataset) {
                    if(typeof dataset.isDash !== 'undefined') {
                        if(dataset.isDash) {
                            // 추후 점선 관련 사이즈 조정이 필요하면 아래 배열 수정 혹은 입력값 표출
                            // dash/dots to zero and space between dots
                            let borderDash = [5, 5];
                            dataset.borderDash = borderDash;
                        }
                    }
                })
            }
            // end: 점선

            // 누적기능
            conf.data.datasets.forEach(function(dataset, i){
                if(typeof dataset.accumulate !== 'undefined') {
                    if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                        if(dataset.accumulate === true) {
                            var accumulateVal = 0;
                            data[dataset.dataKdHdngSqno].forEach(function(v, index){
                                accumulateVal += parseFloat(v);
                                data[dataset.dataKdHdngSqno][index] = accumulateVal;
                            });
                        }
                    }
                }
            });


            // start: 합산 데이터셋 생성
            if(typeof data['-10000'] !== 'undefined'){
                conf.data.datasets.forEach(function(dataset){
                    if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq && Number(dataset.dataKdHdngSqno) > -9999){
                        data[dataset.dataKdHdngSqno].forEach(function(d, index){
                            if(typeof data['-10000'][index] === 'undefined' || isNaN(data['-10000'][index])){
                                data['-10000'][index] = 0;
                            }
                            if(!isNaN(d)){
                                data['-10000'][index] += Number(d);
                            }
                        });
                    }
                });
            }
            // end: 합산 데이터셋 생성

            // start: 평균 데이터셋 생성
            if(typeof data['-30000'] !== 'undefined'){
                let tmpCnt = 0;
                conf.data.datasets.forEach(function(dataset){
                    if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq && Number(dataset.dataKdHdngSqno) > -9999){
                        data[dataset.dataKdHdngSqno].forEach(function(d, index){
                            if(typeof data['-30000'][index] === 'undefined' || isNaN(data['-30000'][index])){
                                data['-30000'][index] = 0;
                            }
                            if(!isNaN(d)){
                                data['-30000'][index] += Number(d);
                            }
                        });
                        tmpCnt++;
                    }
                });
                data['-30000'].forEach(function(d, i){
                    data['-30000'][i] = d / tmpCnt;
                });
            }
            // end: 평균 데이터셋 생성

            // start: 비교 데이터셋 생성
            if(typeof data['-20000'] !== 'undefined'){
                let oDataSeq;
                let oData = [];
                let onData = [];
                let nData = [];
                let nLabel = [];
                let mVal = '';
                conf.data.datasets.forEach(function(dataset){
                    if(typeof dataset.compKdHdngSqno !== 'undefined' && typeof dataset.compUnit !== 'undefined'
                        && typeof data[dataset.compKdHdngSqno] !== 'undefined'){
                        let compKdHdngSqno = dataset.compKdHdngSqno;
                        if(typeof data[compKdHdngSqno + '_mix'] !== 'undefined' && data[compKdHdngSqno + '_mix'].length > 0) {
                            compKdHdngSqno = compKdHdngSqno + '_mix';
                        }
                        oDataSeq = compKdHdngSqno;
                        oData = data[compKdHdngSqno];
                        mVal = Number(dataset.compUnit);
                    }
                });

                if(oData.length > 0 && mVal > 0){
                    let labels = data[conf.data.labelsColumnSeq];
                    for(let ii = 0; ii < labels.length; ii++){
                        let val = labels[ii];
                        let findVal = Number(val) - mVal;
                        labels.forEach(function(dd, index){
                            if(Number(dd) === findVal){
                                onData.push(oData[ii]);
                                nData.push(oData[index]);
                                nLabel.push(val);
                            }
                        });
                    }
                    data[oDataSeq] = onData;
                    data['-20000'] = nData;
                    data[conf.data.labelsColumnSeq] = nLabel;
                }
            }
            // end: 비교 데이터셋 생성

            // start: 백분율로 표기
            if(conf.type !== 'doughnut' && conf.type !== 'pie') {
                let sumTotal = 0;
                conf.data.datasets.forEach(function(dataset){
                    if(typeof dataset.showValuePercent !== 'undefined' && dataset.showValuePercent){
                        if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq){
                            if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                                let total = 0;
                                let vals = [];
                                data[dataset.dataKdHdngSqno].forEach(function(d){
                                    total += Number(d);
                                });
                                if(typeof dataset.showValuePercentSum !== 'undefined' && dataset.showValuePercentSum){
                                    // 데이터 셋 병합하는 경우 total을 따로 저장
                                    sumTotal += total;
                                } else if(!dataset.showValuePercentSum) {
                                    data[dataset.dataKdHdngSqno].forEach(function(d){
                                        vals.push(Number(d) / total * 100);
                                    });
                                    data[dataset.dataKdHdngSqno] = vals;
                                }
                            }
                        }
                    }
                });
                // 데이터 셋 병합하는 경우
                conf.data.datasets.forEach(function(dataset){
                    if(typeof dataset.showValuePercentSum !== 'undefined' && dataset.showValuePercentSum){
                        if(dataset.dataKdHdngSqno !== conf.data.labelsColumnSeq){
                            if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                                let vals = [];
                                data[dataset.dataKdHdngSqno].forEach(function(d){
                                    vals.push(Number(d) / sumTotal * 100);
                                });
                                data[dataset.dataKdHdngSqno] = vals;
                            }
                        }
                    }
                });
            }
            // end: 백분율로 표기

            // 데이터 포맷팅 - 누적 후 포맷팅하도록 수정
            conf.data.datasets.forEach(function(dataset, i){
                if(conf.type == "doughnut" || conf.type == "pie" || conf.type == 'gauge') {
                    var digitFixed = conf.data.datasets[0].digitFixed;
                } else {
                    var digitFixed = dataset.digitFixed;
                }
                if(typeof digitFixed !== 'undefined') {
                    if(typeof data[dataset.dataKdHdngSqno] !== 'undefined') {
                        data[dataset.dataKdHdngSqno].forEach(function(v, index){
                            if(v != "") {
                                if(parseInt(digitFixed) < 0) {
                                    // 절사
                                    data[dataset.dataKdHdngSqno][index] = Math.floor(parseFloat(v) / (parseInt(digitFixed) * -1));
                                } else {
                                    // 소수처리
                                    data[dataset.dataKdHdngSqno][index] = parseFloat(v).toFixed(digitFixed);
                                }
                            }
                        });
                    }
                }

                // start: 라인차트 포인트 설정
                if(dataset.type === 'line' && typeof dataset.customPointRadius !== 'undefined' && dataset.customPointRadius){
                    dataset.pointRadius = 0;
                }
                // end: 라인차트 포인트 설정
            });


            // 건너뛰기 기능 추가
            if(conf.options.stepSize !== 'undefined' && conf.options.stepSize > 1) {
                for(let key in data) {
                    let replaceData = [];
                    data[key].forEach(function(d, index){
                        if(index % conf.options.stepSize === 0) {
                            replaceData.push(d);
                        }
                    });
                    data[key] = replaceData;
                }
            }

            // start: 방사형 차트 설정 - 설정 한벌 새로 만들기 어려움 scales -> scale
            if(conf.type === 'radar'){
                // 기준없는 경우 단일 색상
                if(conf.data.labelsColumnSeq === "-1") {
                    this.isLegend = false;	// 범례제거
                    conf.data.datasets.forEach(function(dataset, ii){
                        if(ii > 0){
                            dataset.backgroundColor = conf.data.datasets[0].backgroundColor;
                            dataset.borderColor = conf.data.datasets[0].borderColor;
                        }
                    });
                }
            }
            // end: 방사형 차트 설정

            if (conf.type === 'bar' || conf.type === 'arrowBar') {
                conf.options.scales.yAxes.forEach(function (axe, axeIdx) {
                    if(typeof axe.ticks.customMiddleAlign !== 'undefined' && axe.ticks.customMiddleAlign
                        && typeof axe.ticks.max !== 'undefined' && axe.ticks.max > 0) {
                        axe.ticks.callback = function (value, index, values) {
                            if (index === 0) {
                                conf.options.scales.yAxes[axeIdx].ticks.min = axe.ticks.max * -1;
                            }
                            if (value >= 0) {
                                return value;
                            }
                        };
                    }
                });
            } else if(conf.type === 'horizontalBar') {
                conf.options.scales.xAxes.forEach(function (axe, axeIdx) {
                    if(typeof axe.ticks.customMiddleAlign !== 'undefined' && axe.ticks.customMiddleAlign
                        && typeof axe.ticks.max !== 'undefined' && axe.ticks.max > 0) {
                        axe.ticks.callback = function (value, index, values) {
                            if (index === 0) {
                                conf.options.scales.xAxes[axeIdx].ticks.min = axe.ticks.max * -1;
                            }
                            if (value >= 0) {
                                return value;
                            }

                        };
                    }
                    if(typeof conf.isSideDisplay !== 'undefined' && conf.isSideDisplay
                            /*&& typeof axe.ticks.max !== 'undefined' && axe.ticks.max > 0*/) {
                        // 첫번째만 음수처리
                        if(axeIdx == 0) {
                            axe.ticks.callback = function(value, index) {
                                if (index === 0) {
                                    conf.options.scales.xAxes[axeIdx].ticks.min = axe.ticks.max * -1;
                                }
                                return Math.abs(value).toLocaleString();                    
                            }
                        }
                    }
                    if(typeof conf.yInterVal !== 'undefined' && conf.yInterVal > 0) {
                        let showValueInterval = conf.yInterVal;
                        conf.options.scales.yAxes.forEach(function (axe, axeIdx) {
                            axe.ticks.callback = function(value, index, values) {
                                let idx = (values.length -1) - index;
                                let returnVal = value;
                                if(typeof conf.options.formmaterAddText !== 'undefined') {
                                    returnVal += conf.options.formmaterAddText;
                                }
                                if(idx != 0 && idx % showValueInterval != 0) {
                                    returnVal = '';
                                }
                                return returnVal;
                            }
                        });                    
                    }
                });
            }

            // 특정바의 색상을 변경한다
            if(conf.type === 'bar' || conf.type === 'horizontalBar' || conf.type === 'arrowBar') {
                // start: 파라미터로 처리
                conf.data.datasets.forEach(function(dataset, i){
                    if(dataset.replaceColorType === 'param'
                        && typeof dataset.replaceColorValue !== 'undefined'
                        && dataset.replaceColorValue !== '') {
                        if(vm.params.indexOf(dataset.replaceColorValue) > -1){
                            let pObj = new URLSearchParams(vm.params);
                            dataset.replaceColorType = 'equal';
                            dataset.replaceColorValue = pObj.get(dataset.replaceColorValue);
                        }
                    }
                });
                // end: 파라미터로 처리
                conf.data.datasets.forEach(function(dataset, i){
                    if(typeof dataset.useMultiBackgroundColor !== 'undefined' && dataset.useMultiBackgroundColor){
                        dataset.backgroundColor = dataset.multiBackgroundColors;
                        dataset.borderColor = dataset.multiBackgroundColors;
                    }
                    if(typeof dataset.replaceColorType !== 'undefined' && dataset.replaceColorType !== ''
                        && typeof dataset.replaceColor !== 'undefined') {
                        let defaultColor = dataset.backgroundColor;
                        let replaceColors = [];

                        if(dataset.replaceColorType === 'over'
                            && typeof dataset.replaceColorValue !== 'undefined'
                            && dataset.replaceColorValue !== '' && !isNaN(dataset.replaceColorValue)) {
                            // 특정 값 이상의 색상을 변경한다.
                            data[dataset.dataKdHdngSqno].forEach(function(v){
                                if(Number(v) >= Number(dataset.replaceColorValue)) {
                                    replaceColors.push(dataset.replaceColor);
                                } else {
                                    replaceColors.push(defaultColor);
                                }
                            });
                        } else if(dataset.replaceColorType === 'down') {
                            // 특정 값 이하의 색상을 변경한다.
                            data[dataset.dataKdHdngSqno].forEach(function(v){
                                if(Number(v) <= Number(dataset.replaceColorValue)) {
                                    replaceColors.push(dataset.replaceColor);
                                } else {
                                    replaceColors.push(defaultColor);
                                }
                            });
                        } else if(dataset.replaceColorType === 'max') {
                            // 가장 높은 값의 색상을 변경한다.
                            let replaceVal = Math.max.apply(null, data[dataset.dataKdHdngSqno]);
                            if(!isNaN(replaceVal)) {
                                data[dataset.dataKdHdngSqno].forEach(function(v){
                                    if(Number(replaceVal) === Number(v)) {
                                        replaceColors.push(dataset.replaceColor);
                                    } else {
                                        replaceColors.push(defaultColor);
                                    }
                                });
                            }
                        } else if(dataset.replaceColorType === 'min') {
                            // 가장 낮은 값의 색상을 변경한다.
                            let replaceVal = Math.min.apply(null, data[dataset.dataKdHdngSqno]);
                            if(!isNaN(replaceVal)) {
                                data[dataset.dataKdHdngSqno].forEach(function(v){
                                    if(Number(replaceVal) === Number(v)) {
                                        replaceColors.push(dataset.replaceColor);
                                    } else {
                                        replaceColors.push(defaultColor);
                                    }
                                });
                            }
                        } else if(dataset.replaceColorType === 'equal'
                            && typeof dataset.replaceColorValue !== 'undefined'
                            && dataset.replaceColorValue !== '') {
                            // 특정 기준 값의 색상을 변경한다
                            if(typeof data[conf.data.labelsColumnSeq] !== 'undefined') {
                                let replaceIdx = '';
                                data[conf.data.labelsColumnSeq].forEach(function(d, idx){
                                    if(d === dataset.replaceColorValue) {
                                        replaceIdx = idx;
                                    }
                                });
                                if(replaceIdx !== '') {
                                    data[dataset.dataKdHdngSqno].forEach(function(v, idx){
                                        if(idx === replaceIdx) {
                                            replaceColors.push(dataset.replaceColor);
                                        } else {
                                            replaceColors.push(defaultColor);
                                        }
                                    });
                                }
                            }
                        }

                        // 컬러변경이 있는 경우 세팅
                        if(replaceColors.length > 0) {
                            dataset.backgroundColor = replaceColors;
                            dataset.borderColor = replaceColors;
                            dataset.defaultColor = defaultColor;
                        }
                    }
                });
            }

            // 기준없는 차트 dataset merge..
            if(conf.data.labelsColumnSeq == "-1") {
                // 높은순으로 데이터 셋 정렬 - 트리맵은 무조건 높은 값 부터..
                if(conf.type === 'treemap'){
                    let treemapSetList = ['fontColor', 'borderColor'];
                    let treemapSets = {};
                    treemapSetList.forEach(function(key){
                        if(typeof conf.data.datasets[0][key] !== 'undefined'){
                            treemapSets[key] = conf.data.datasets[0][key];
                        }
                    });
                    conf.data.datasets.forEach(function(dataset){
                        dataset.bindData = 0;
                        dataset.type = conf.type;
                        data[dataset.dataKdHdngSqno].forEach(function(d){
                            dataset.bindData += Number(d);
                        });
                    });
                    conf.data.datasets.sort(function(p, c){
                        return c.bindData - p.bindData;
                    });
                    for(let key in treemapSets){
                        conf.data.datasets[0][key] = treemapSets[key];
                    }
                }

                if(conf.type != "doughnut" && conf.type != "pie") {
                    // this.isLegend = false; // 기준이 없는 경우 범례를 보여줄 수 없다
                }
                var newData = {};
                var newDatasets = [];
                var backgroundColors = [];
                var borderColors = [];
                var labels = [];
                conf.data.datasets.forEach(function(dataset, i){
                    if(typeof newData[conf.data.labelsColumnSeq] === "undefined") {
                        newData[conf.data.labelsColumnSeq] = [];
                    }
                    newData[conf.data.labelsColumnSeq].push(dataset.label);

                    var val = 0;
                    data[dataset.dataKdHdngSqno].forEach(function(v){
                        val += parseFloat(v);
                    });

                    if(typeof newData[conf.data.datasets[0].dataKdHdngSqno] === "undefined") {
                        newData[conf.data.datasets[0].dataKdHdngSqno] = [];
                    }
                    newData[conf.data.datasets[0].dataKdHdngSqno].push(val);

                    if(i == 0) {
                        newDatasets.push(dataset);
                    }

                    if(conf.type === 'treemap'){
                        borderColors.push(conf.data.datasets[0].borderColor);
                    }

                    if(typeof dataset.backgroundColor !== 'undefined' && dataset.backgroundColor != '') {
                        backgroundColors.push(dataset.backgroundColor);

                    }
                    if(typeof dataset.label !== 'undefined' && dataset.label != '') {
                        labels.push(dataset.label);
                    }
                });

                data = newData;
                if(conf.type != "doughnut" && conf.type != "pie") {
                    newDatasets[0].backgroundColor = backgroundColors;
                    if(borderColors.length === 0){
                        newDatasets[0].borderColor = backgroundColors;
                    } else {
                        newDatasets[0].borderColor = borderColors;
                    }
                    newDatasets[0].label = labels;
                }
                conf.data.datasets = newDatasets;
            }

            if(typeof conf.options.maxTicksLimit !== "undefined") {
                if(conf.options.maxTicksLimit > 0) {
                    var axesSeq = conf.data.labelsColumnSeq;
                    var limitData = {};
                    var sumData = {};
                    var overText = "";

                    let maxTicksType = 'front';
                    if(typeof conf.options.maxTicksType !== "undefined") {
                        maxTicksType = conf.options.maxTicksType;
                    }

                    if(typeof conf.options.maxTicksLimitOverText !== "undefined") {
                        if(conf.options.maxTicksLimitOverText != "") {
                            overText = conf.options.maxTicksLimitOverText;
                        }
                    }

                    for(let key in data) {
                        if(maxTicksType === 'back') {
                            data[key].reverse();
                        }
                        for(var i = 0; i < data[key].length; i++) {
                            if(i >= conf.options.maxTicksLimit) {
                                if(key == axesSeq && overText != "") {
                                    sumData[key] = overText;
                                } else {
                                    if(typeof sumData[key] === "undefined") {
                                        sumData[key] = 0;
                                    }
                                    sumData[key] += parseFloat(data[key][i]);
                                }
                            } else {
                                if(typeof limitData[key] === "undefined") {
                                    limitData[key] = [];
                                }
                                limitData[key].push(data[key][i]);
                            }
                        }
                        if(maxTicksType === 'back') {
                            limitData[key].reverse();
                        }
                    }

                    if(overText != "") {
                        for(let key in limitData) {
                            if(typeof sumData[key] !== 'undefined') {
                                limitData[key].push(sumData[key]);
                            }
                        }
                    }
                    data = limitData;
                }
            }
            return data;
        },
        setBreakpoints: function(conf) {
        	if(typeof conf.breakpoints !== 'undefined' && conf.breakpoints.length > 0){
        		conf.breakpoints.forEach(function(c) {
        			if(this.$refs._gripchart.offsetWidth >= c.minWidth && this.$refs._gripchart.offsetWidth < c.maxWidth){
        				$.extend(true, conf, c.config);
        			}
        		}.bind(this));
        	}
        },
        setChartConf: function(conf) {
            this.setBreakpoints(conf);
            // 폰트 색상 변경 추가
            if(this.fontColor !== ''){

                conf.data.datasets.forEach(function(dataset) {
                    dataset.showValue.textColor = this.fontColor;
                }.bind(this));
                for(let key in conf.options.scales){
                    conf.options.scales[key].forEach(function(axes) {
                        axes.scaleLabel.fontColor = this.fontColor;
                        axes.ticks.fontColor = this.fontColor;
                    }.bind(this));
                }
            }

            if(conf.type === 'doughnut') {
                if(typeof conf.doughnut !== 'undefined' && typeof conf.doughnut.cutoutPercentage !== 'undefined') {
                    conf.options.cutoutPercentage = conf.doughnut.cutoutPercentage;
                }
            }
            // 파이차트 범례 우측나열 기능
            if(typeof conf.options.showRightLegend !== 'undefined' && conf.options.showRightLegend === true) {
                this.addClass.push('pie');
                this.legendClass = 'grp_legend2';
            }

            let hiddenDataKdHdngSqno = [];
            conf.data.datasets.forEach(function(dataset, index){
                if(typeof dataset.hidden !== 'undefined' && dataset.hidden === true) {
                    hiddenDataKdHdngSqno.push(dataset.dataKdHdngSqno);
                }
            });

            // 범례 노출 여부 추가
            if(typeof conf.options.hideLegend !== 'undefined' && conf.options.hideLegend === true) {
                this.isLegend = false;
            }

            // start: 증가 값 단위가 실수인 경우 모두 0일때 max값이 자동으로 1로 세팅되어 추가
            var totalVal = 0;
            conf.data.datasets.forEach(function(dataset){
                if(typeof dataset.data !== 'undefined' && dataset.data.length > 0){
                    dataset.data.forEach(function(v){
                        totalVal += v;
                    });
                }
            });

            if(totalVal == 0) {
                if(conf.type == "bar" || conf.type == "line") {
                    conf.options.scales.yAxes.forEach(function(axes){
                        if(typeof axes.ticks.max === 'undefined'
                            && typeof axes.ticks.stepSize !== 'undefined'
                            && axes.ticks.stepSize != ''
                            && axes.ticks.stepSize.indexOf(".") > -1) {
                            axes.ticks.max = axes.ticks.stepSize * 5;
                        }
                    });
                } else if(conf.type == "horizontalBar") {
                    conf.options.scales.xAxes.forEach(function(axes){
                        if(typeof axes.ticks.max === 'undefined'
                            && typeof axes.ticks.stepSize !== 'undefined'
                            && axes.ticks.stepSize != ''
                            && axes.ticks.stepSize.indexOf(".") > -1) {
                            axes.ticks.max = axes.ticks.stepSize * 5;
                        }
                    });
                }
            }
            // end: 증가 값 단위가 실수인 경우 모두 0일때 max값이 자동으로 1로 세팅되어 추가

            // start: 기본색상지정
            if(typeof conf.options.scales !== 'undefined'){
                conf.options.scales.xAxes.forEach(function(v){
                    if(typeof v.barPercentag !== 'undefined' && v.barPercentag !== '' && !isNaN(v.barPercentag)) {
                        // 잘못 세팅한 차트 기본 값으로 변경
                        v.barPercentag = 0.9;
                    }
                    if(typeof v.scaleLabel.fontColor === "undefined") {
                        v.scaleLabel.fontColor = "#cacfd8";
                    }
                    if(typeof v.ticks.fontColor === "undefined") {
                        v.ticks.fontColor = "#cacfd8";
                    }
                    // 바 차트 두께 설정
                    if(typeof v.barThickness !== 'undefined' && v.barThickness !== '' && !isNaN(v.barThickness)) {
                        v.maxBarThickness = v.barThickness - 1;
                        if(this.viewScale > 2) {
                            v.barThickness = v.barThickness * 2;
                            v.maxBarThickness = v.barThickness - 2;
                        }
                    } else {
                        v.barThickness = 'flex';
                    }
                }.bind(this));

                conf.options.scales.yAxes.forEach(function(v){
                    if(typeof v.scaleLabel.fontColor === "undefined") {
                        v.scaleLabel.fontColor = "#cacfd8";
                    }
                    if(typeof v.ticks.fontColor === "undefined") {
                        v.ticks.fontColor = "#cacfd8";
                    }
                    // 바 차트 두께 설정
                    if(typeof v.barThickness !== 'undefined' && v.barThickness !== '' && !isNaN(v.barThickness)) {
                        v.maxBarThickness = v.barThickness - 1;
                        if(this.viewScale > 2) {
                            v.barThickness = v.barThickness * 3;
                            v.maxBarThickness = v.barThickness - 3;
                        }
                    } else {
                        v.barThickness = 'flex';
                    }
                }.bind(this));
            }
            // end: 기본색상지정

            var displayMode = "pc";
            if(this.viewScale > 2) {
                displayMode = "did";
            }
            Chart.defaults.global.defaultFontSize = 10 + (7 * (this.viewScale - 1));
            
            var vm = this;
            if(typeof vm.chartTitle !== 'undefined' && vm.chartTitle != '') {
                vm.title = vm.chartTitle;
            } else {
                vm.title = conf.options.title.text;
            }
            if(typeof vm.chartTitleSuffix !== 'undefined' && vm.chartTitleSuffix != '') {
                vm.title += vm.chartTitleSuffix;
            }
            if(conf.data.datasets[0].addTitleParam === true) {
                if(vm.params.split('=')[1] !== 'undefined') {
                    vm.title += ' : ' + vm.params.split('=')[1];
                }
            }
            vm.title = vm.unescapeHtml(vm.title);

            if(typeof vm.chartStand !== 'undefined' && vm.chartStand != '') {
                vm.stand = vm.chartStand;
            } else {
                if(typeof conf.options.chartStand !== 'undefined' && conf.options.chartStand != ''
                    && typeof vm.maxDate !== 'undefined'
                    && (conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('mm') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('dd') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('qq') > -1
                        || conf.options.chartStand.toLowerCase().indexOf('half') > -1)) {
                    let yyyy = '';
                    let mm = '';
                    let dd = '';
                    let qq = '';
                    let half = '';

                    if(conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1) {
                        yyyy = vm.maxDate.substring(0,4);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('mm') > -1) {
                        mm = vm.maxDate.substring(4,6);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('dd') > -1) {
                        dd = vm.maxDate.substring(6,8);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('qq') > -1) {
                        qq = vm.maxDate.substring(4,6);
                    }
                    if(conf.options.chartStand.toLowerCase().indexOf('half') > -1) {
                        if(vm.maxDate.substring(5,6) === '1'){
                            half = '상';
                        }else{
                            half = '하';
                        }
                    }

                    let yearDelimiter = '년 ';
                    let monthDelimiter = '월 ';
                    let dayDelimiter = '일 ';
                    let quarterDelimiter = '분기 ';
                    let halfDelimiter = '반기'
                    if(typeof conf.standDelimiter !== 'undefined' && conf.standDelimiter !== '') {
                        yearDelimiter = '';
                        monthDelimiter = '';
                        dayDelimiter = '';
                        quarterDelimiter = '';
                        if(dd !== '') {
                            monthDelimiter = conf.standDelimiter;
                        }
                        if(mm !== '') {
                            yearDelimiter = conf.standDelimiter;
                        }
                        if(qq !== '') {
                            yearDelimiter = conf.standDelimiter;
                        }
                        if(half !== '') {
                            yearDelimiter = conf.standDelimiter;
                        }
                    }

                    let stand = "";
                    stand += (yyyy !== '' && conf.options.chartStand.toLowerCase().indexOf('yyyy') > -1) ? yyyy + yearDelimiter : '';
                    stand += (mm !== '' && conf.options.chartStand.toLowerCase().indexOf('mm') > -1) ? mm + monthDelimiter : '';
                    stand += (dd !== '' && conf.options.chartStand.toLowerCase().indexOf('dd') > -1) ? dd + dayDelimiter : '';
                    stand += (qq !== '' && conf.options.chartStand.toLowerCase().indexOf('qq') > -1) ? qq + quarterDelimiter : '';
                    stand += (half !== '' && conf.options.chartStand.toLowerCase().indexOf('half') > -1) ? half + halfDelimiter : '';
                    stand += ' 기준';
                    vm.stand = stand;
                } else {
                    vm.stand = conf.options.chartStand;
                }
            }

            if(typeof vm.chartUnit !== 'undefined' && vm.chartUnit != '') {
                vm.unit = vm.chartUnit;
            } else {
                vm.unit = conf.options.chartUnit;
            }
            if(typeof vm.chartSource !== 'undefined' && vm.chartSource != '') {
                vm.source = vm.chartSource;
            } else {
                vm.source = conf.options.chartSource;
            }
            if(typeof vm.chartDesc !== 'undefined' && vm.chartDesc != '') {
                vm.desc = vm.chartDesc;
            } else {
                if(typeof conf.options.chartDesc !== 'undefined' && conf.options.chartDesc != '') {
                    vm.desc = conf.options.chartDesc;
                }
            }

            conf.options.title.display = false;
            conf.options.legend = {};
            conf.options.legend.display = false;
            conf.options.maintainAspectRatio = false;

            if(typeof conf.options.layout === "undefined") {
                conf.options.layout = {};
                var padding = {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                };

                if(conf.type == "bar" || conf.type == "line" || 'arrowBar') {
                    padding.top = 20;
                } else if(conf.type == "horizontalBar") {
                    padding.right = 100;
                } else if(conf.type == "doughnut" || conf.type == "pie") {
                    padding.top = 20;
                    padding.bottom = 20;
                }
            }

            // 피벗
            if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                if(conf.options.mergeDataKdHdngSqno != "") {
                    var i = -100;
                    conf.data.datasets.forEach(function(dataset) {
                        if(dataset.dataKdHdngSqno !== '-10000'){
                            dataset.dataKdHdngSqno = ""+i;
                            i--;
                        }
                    });
                }
            }

            // 마우스 오버 툴팁 포멧 변경
            var callbacks = {};
            callbacks.label = function(tooltipItem, data) {
                if(conf.type == "bar" || conf.type == "line" || conf.type == 'arrowBar') {
                    if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                        if(conf.data.labelsColumnSeq == "-1") {
                            var dataLabel = tooltipItem.label;
                            return dataLabel + ': ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                        var dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                        return dataLabel + ': ' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if(conf.type == "horizontalBar") {
                    if(typeof conf.options.mergeDataKdHdngSqno !== "undefined") {
                        if(conf.data.labelsColumnSeq == "-1") {
                            var dataLabel = tooltipItem.label;
                            // 좌우표출의 경우 양수로 표출
                            return dataLabel + ': ' + (typeof conf.isSideDisplay !== 'undefined' && conf.isSideDisplay
                                    ? Math.abs(tooltipItem.xLabel).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                        }
                        var dataLabel = data.datasets[tooltipItem.datasetIndex].label;
                        if(typeof conf.yInterVal !== 'undefined' && conf.yInterVal > 0) {
                            tooltipItem.label = data.labels[tooltipItem.index];
                            tooltipItem.yLabel = data.labels[tooltipItem.index];
                        }
                        return dataLabel + ': ' + (typeof conf.isSideDisplay !== 'undefined' && conf.isSideDisplay
                                ? Math.abs(tooltipItem.xLabel).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    }
                    return tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if(conf.type == "doughnut" || conf.type == "pie") {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (Chart.helpers.isArray(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else {
                        dataLabel += value;
                    }
                    return dataLabel;
                } else if(conf.type === 'treemap') {
                    let dataset = data.datasets[tooltipItem.datasetIndex];
                    let dataItem = dataset.data[tooltipItem.index];
                    let dataLabel = dataset.label;
                    dataLabel += ': ' + dataItem.v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return dataLabel;
                } else if(conf.type === 'gauge') {
                    data.datasets[0].labels.forEach(function(label) {
                        if(typeof label === 'undefined' || label === '') {
                            label = data.datasets[0].data[tooltipItem.index];
                        }
                    });
                    return data.datasets[0].labels[tooltipItem.index];
                }
            };

            if(conf.type === 'treemap') {
                callbacks.title = function(item, data) {
                    let dataset = data.datasets[item[0].datasetIndex];
                    return dataset.data[item[0].index].g;
                };
            }

            callbacks.afterBody = function(t, d){
                let index = t[0].index;
                if(hiddenDataKdHdngSqno.length > 0) {
                    let list = [];
                    hiddenDataKdHdngSqno.forEach(function(dataKdHdngSqno){
                        let map = {labelColors: '', label: '', data: ''};
                        d.datasets.forEach(function(dataset){
                            if(dataset.dataKdHdngSqno === dataKdHdngSqno) {
                                map.labelColors = dataset.backgroundColor;
                                map.label = dataset.label;
                                map.data = dataset.data[index];
                            }
                        });
                        list.push(map);
                    });
                    return list;
                }
            };
            conf.options.tooltips.callbacks = callbacks;

            conf.options.tooltips.enabled = false;
            conf.options.tooltips.custom = function(tooltipModel) {
                // Tooltip Element
                // var tooltipEl = document.getElementById('chartjs-tooltip');
                var tooltipEl = document.getElementById('chartjs-tooltip');
                if(conf.type === 'radar' || conf.type === 'treemap'){
                    if(typeof tooltipModel.dataPoints !== 'undefined'){
                        tooltipModel.dataPoints.forEach(function(dataPoint, ii){
                            let tmpLabel = '';
                            if(Array.isArray(conf.data.datasets[dataPoint.datasetIndex].label)){
                                tmpLabel = conf.data.datasets[dataPoint.datasetIndex].label[dataPoint.index];
                            } else {
                                tmpLabel = conf.data.datasets[dataPoint.datasetIndex].label;
                            }
                            if(conf.type === 'radar'){
//                				tmpLabel += ': ' + dataPoint.yLabel
                                tmpLabel += ': ' + conf.data.datasets[dataPoint.datasetIndex].data[dataPoint.index];
                            } else if(conf.type === 'treemap'){
                                tmpLabel += ': ' + conf.data.datasets[dataPoint.datasetIndex].data[dataPoint.index].v;
                            }
                            tooltipModel.body[ii].lines = [tmpLabel];
                        });
                    }
                }

                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    tooltipEl.style.opacity = 0;
                    tooltipEl.style.display = "none";
                    document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    tooltipEl.style.display = "none";
                    return;
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem) {
                    return bodyItem.lines;
                }

                let raceSize = tooltipModel.bodyFontSize;
                let fontSize = tooltipModel.bodyFontSize;

                // Set Text
                if (tooltipModel.body) {
                    var titleLines = tooltipModel.title || [];
                    var bodyLines = tooltipModel.body.map(getBody);
                    if(typeof conf.yInterVal !== 'undefined' && conf.yInterVal > 0) {
                        let yLabel = tooltipModel.dataPoints[0].yLabel;
                        if(typeof conf.options.formmaterAddText !== 'undefined') {
                            yLabel += conf.options.formmaterAddText;
                        }
                        titleLines = [yLabel] || [];
                    }
                    var innerHtml = '<caption>Chart</caption><thead>';
                    if(conf.type !== 'gauge') {
                        titleLines.forEach(function(title) {
                            innerHtml += '<tr><th style="color: #fff; text-align: left;">' + title + '</th></tr>';
                        });
                    }
                    innerHtml += '</thead><tbody style="text-align: left;">';
                    bodyLines.forEach(function(body, i) {
                        var colors = tooltipModel.labelColors[i];
                        var style = 'background:' + colors.backgroundColor;
                        style += '; border-color:' + colors.borderColor;
                        style += '; border-width: 2px';
                        style += '; width: ' + raceSize + 'px';
                        style += '; height: ' + raceSize + 'px';
                        style += '; display: inline-block';
                        var span = '<span style="' + style + '"></span>';
                        innerHtml += '<tr><td style="color: #fff">' + span + ' ' + body + '</td></tr>';
                    });

                    if(typeof tooltipModel.afterBody !== 'undefined' && tooltipModel.afterBody.length > 0) {
                        tooltipModel.afterBody.forEach(function(body){
                            if(body.labelColors !== '' && body.label !== '' && body.data !== '') {
                                let color = body.labelColors;
                                let style = 'background:' + color;
                                style += '; border-color:' + color;
                                style += '; border-width: 2px';
                                style += '; width: ' + raceSize + 'px';
                                style += '; height: ' + raceSize + 'px';
                                style += '; display: inline-block';
// let span = '<span style="' + style + '"></span>';
                                let span = '';  // 차트가 없으니 색상표기 하지 않음
                                innerHtml += '<tr><td style="color: #fff">' + span + ' ' + body.label + ': ' + body.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); + '</td></tr>';
                            }
                        });
                    }
                    innerHtml += '</tbody>';
                    tooltipEl.innerHTML = '<table>' + innerHtml + '</table>';
                }

                var position = this._chart.canvas.getBoundingClientRect();

                let modelWidth = 0;
                if(position.width / 2 < tooltipModel.caretX) {
                    modelWidth = tooltipModel.width
                }

                let positionLeft = position.left + window.pageXOffset + tooltipModel.caretX - modelWidth;
                let positionTop = position.top + window.pageYOffset + tooltipModel.caretY - (tooltipModel.height / 2);

                // TODO 툴팁위치 추가 (차후 고려해본다)
// if(typeof conf.tooltipConf !== 'undefined') {
// if(typeof conf.tooltipConf.position !== 'undefined') {
// if(conf.tooltipConf.position === 'bottom') {
// if(conf.type == "bar" || conf.type == "line") {
// positionTop = position.bottom - position.top;
// } else if(conf.type == "horizontalBar") {
// positionLeft = position.left;
// }
// }
// }
// }

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 0.9;
                tooltipEl.style.position = 'absolute';
                tooltipEl.style.left = positionLeft + 'px';
                tooltipEl.style.top = positionTop + 'px';
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = fontSize + 'px';
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                tooltipEl.style.pointerEvents = 'none';
                tooltipEl.style.zIndex = 2147483647;
                tooltipEl.style.backgroundColor = 'black';
                tooltipEl.style.borderRadius = '6px';
                tooltipEl.style.width = 'max-content';
                tooltipEl.style.display = "block";
            };

            // 축 데이터 포멧 변경
            if(conf.type == "bar" || conf.type == "line" || conf.type == 'arrowBar') {
                conf.options.scales.yAxes.forEach(function(yAxes){
                    yAxes.ticks.callback = function (value) {
                        if(value.toString().indexOf(".") == -1) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return value.toString();
                        }
                    };
                });

                conf.options.scales.xAxes[0].ticks.callback = function (value) {
                    if(value != null) {
                        var length = value.length;
                        if(typeof conf.options.formmaterStart !== 'undefined' && conf.options.formmaterStart !== ''
                            && typeof conf.options.formmaterEnd !== 'undefined' && conf.options.formmaterEnd !== '') {
                            value = value.substring(conf.options.formmaterStart, conf.options.formmaterEnd);

                            if(typeof conf.options.formmaterLengthAddText !== 'undefined' && length > conf.options.formmaterEnd) {
                                value += conf.options.formmaterLengthAddText;
                            }
                        }

                        if(typeof conf.options.formmaterAddText !== 'undefined') {
                            value += conf.options.formmaterAddText;
                        }

//                        // 복합자르기
//                        if(typeof conf.options.formatter !== 'undefined') {
//                            if(conf.options.formatter.length > 0) {
//                                let newValue = "";
//                                conf.options.formatter.forEach(function(formatter){
//                                    if(!isNaN(formatter.start) && !isNaN(formatter.end)) {
//                                        if(newValue != "") {
//                                        	// 자간 삭제기능 추가
//                                        	if(typeof conf.options.formatTrim === 'undefined' || conf.options.formatTrim === false){
//                                        		newValue += " ";
//                                        	}
//                                        }
//                                        newValue += value.substring(formatter.start, formatter.end) + formatter.addText;
//                                    }
//                                });
//                                if(newValue != "") {
//                                    value = newValue;
//                                }
//                            }
//                        }
//
//                        // 추출
//                        if(typeof conf.options.extract !== 'undefined' && conf.options.extract.gubun !== '' && conf.options.extract.number > 0) {
//                        	let tmpValue = value.split(conf.options.extract.gubun);
//                        	if(typeof tmpValue[conf.options.extract.number - 1] !== 'undefined'){
//                        		value = tmpValue[conf.options.extract.number - 1];
//                        	}
//                        }
                        value = vm.setStandardVal(conf, value);
                    }
                    return value;
                };
            } else if(conf.type == "horizontalBar") {
                conf.options.scales.xAxes.forEach(function(xAxes){
                    xAxes.ticks.callback = function (value) {
                        if(value.toString().indexOf(".") == -1) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return value.toString();
                        }
                    };
                });

                conf.options.scales.yAxes[0].ticks.callback = function (value) {
                    if(value != null) {
                        var length = value.length;
                        if(typeof conf.options.formmaterStart !== 'undefined' && conf.options.formmaterStart !== ''
                            && typeof conf.options.formmaterEnd !== 'undefined' && conf.options.formmaterEnd !== '') {
                            value = value.substring(conf.options.formmaterStart, conf.options.formmaterEnd);

                            if(typeof conf.options.formmaterLengthAddText !== 'undefined' && length > conf.options.formmaterEnd) {
                                value += conf.options.formmaterLengthAddText;
                            }
                        }

                        if(typeof conf.options.formmaterAddText !== 'undefined') {
                            value += conf.options.formmaterAddText;
                        }

                        // 복합자르기
                        if(typeof conf.options.formatter !== 'undefined') {
                            if(conf.options.formatter.length > 0) {
                                let newValue = "";
                                conf.options.formatter.forEach(function(formatter){
                                    if(!isNaN(formatter.start) && !isNaN(formatter.end)) {
                                        if(newValue != "") {
                                            // 자간 삭제기능 추가
                                            if(typeof conf.options.formatTrim === 'undefined' || conf.options.formatTrim === false){
                                                newValue += " ";
                                            }
                                        }
                                        newValue += value.substring(formatter.start, formatter.end) + formatter.addText;
                                    }
                                });
                                if(newValue != "") {
                                    value = newValue;
                                }
                            }
                        }

                        // 추출
                        if(typeof conf.options.extract !== 'undefined' && conf.options.extract.gubun !== '' && conf.options.extract.number > 0) {
                            let tmpValue = value.split(conf.options.extract.gubun);
                            if(typeof tmpValue[conf.options.extract.number - 1] !== 'undefined'){
                                value = tmpValue[conf.options.extract.number - 1];
                            }
                        }
                    }
                    return value;
                };
            }

            // showValue 애니메이션으로 변경
            var animationColors = [];
            conf.data.datasets.forEach(function (dataset, i) {
                if(typeof dataset.showValue !== 'undefined' && dataset.showValue.display === true && vm.showGrpValue === true) {
                    var tmpAnimation = {};
                    if(typeof dataset.mixDataKdHdng !== 'undefined' && dataset.mixDataKdHdng.length > 0) {
                        tmpAnimation.key = dataset.dataKdHdngSqno + '_mix';
                    } else {
                        tmpAnimation.key = dataset.dataKdHdngSqno;
                    }
                    tmpAnimation.value = dataset.showValue.textColor;
                    animationColors.push(tmpAnimation);
                    dataset.showValue.display = false;
                }
            });

            // 동작이슈로 onComplete 이전에 선언한다
            if(conf.type === "doughnut" && typeof conf.doughnut !== 'undefined') {
                if(vm.viewScale > 1 && conf.doughnut.centerTextSize !== '') {
                    conf.doughnut.centerTextSize = Math.round(Number(conf.doughnut.centerTextSize) * 1.2);
                }
            }
            let animation = {};
            if(animationColors.length > 0) {
                animation.onComplete = function () {

                    // 폰트사이즈 확대 적용
                    let fontSize = Chart.defaults.global.defaultFontSize * vm.fontMagnification;

                    var chartInstance = this.chart,
                        ctx = chartInstance.ctx;
                    // 폰트사이즈 확대 적용
                    // ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.font = Chart.helpers.fontString(fontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    if(conf.type == "horizontalBar") {
                        ctx.textAlign = 'left';
                    }

                    if(conf.type == "doughnut" || conf.type == "pie") {
                        let totalValue = 0;
                        let totalCount = 0;
                        let centerX = 0;
                        let centerY = 0;
                        if(conf.showValueConstant || conf.showValuePercent) {
                            this.data.datasets.forEach(function (dataset) {
                                for (var i = 0; i < dataset.data.length; i++) {
                                    totalValue += Number(dataset.data[i]);
                                    totalCount++;

                                    var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                                        total = dataset._meta[Object.keys(dataset._meta)[0]].total;

                                    centerX = model.x;
                                    centerY = model.y;

                                    let start_angle = model.startAngle;
                                    let end_angle = model.endAngle;
                                    let mid_angle = start_angle + (end_angle - start_angle)/2;
                                    let mid_radius;
                                    // 몇부터 외곽선에 표기할것 인지
                                    if(typeof conf.showValueOutline !== 'undefined' && parseInt(conf.showValueOutline) > 0) {
                                        if(Math.round(dataset.data[i]/total*100) < parseInt(conf.showValueOutline)) {
                                            var pad = 20 - Math.ceil(mid_angle  * 3);
                                            mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius) + pad;
                                        } else {
                                            mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2;
                                        }
                                    } else {
                                        mid_radius = model.innerRadius + (model.outerRadius - model.innerRadius)/2;
                                    }

                                    var x = mid_radius * Math.cos(mid_angle);
                                    var y = mid_radius * Math.sin(mid_angle);

                                    ctx.fillStyle = animationColors[0].value;

                                    var data = "";
                                    if(parseFloat(dataset.data[i]) > 0) {
                                        if(conf.showValueConstant) {
                                            var val = parseFloat(dataset.data[i]);
                                            data += val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        if(conf.showValuePercent) {
                                            var percent = String(Math.round(dataset.data[i]/total*100)) + "%";
                                            if(data != "") {
                                                data += " ("+percent+")";
                                            } else {
                                                data += percent;
                                            }
                                        }
                                    }

                                    if(typeof conf.showValueRemove !== 'undefined' && parseInt(conf.showValueRemove) > 0) {
                                        if(Math.round(dataset.data[i]/total*100) >= parseInt(conf.showValueRemove)) {
                                            ctx.fillText(data, model.x + x, model.y + y);
                                        }
                                    } else {
                                        ctx.fillText(data, model.x + x, model.y + y);
                                    }
                                }
                            });

                            if(conf.type === "doughnut" && typeof conf.doughnut !== 'undefined') {
                                if(typeof conf.doughnut.showCenterText !== 'undefined' && conf.doughnut.showCenterText === 'true') {
                                    let viewVal = totalValue;
                                    if(conf.doughnut.centerTextType === 'avg') {
                                        viewVal = (totalValue / totalCount).toFixed(2);
                                    }
                                    let size = Number(Chart.defaults.global.defaultFontSize) * Number(conf.doughnut.centerTextSize);
                                    let font = Chart.helpers.fontString(size, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                                    ctx.font = font;
                                    let textY = centerY + (size / 2);

                                    if(typeof conf.doughnut.centerValdigitFixed !== 'undefined') {
                                        let digitFixed = conf.doughnut.centerValdigitFixed;
                                        if(typeof digitFixed !== 'undefined') {
                                            if(parseInt(digitFixed) < 0) {
                                                viewVal = Math.floor(parseFloat(viewVal) / (parseInt(digitFixed) * -1));
                                            } else {
                                                viewVal = parseFloat(viewVal).toFixed(digitFixed);
                                            }
                                        }
                                    }

                                    let text = viewVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    if(typeof conf.doughnut.centerAddText !== 'undefined') {
                                        text += conf.doughnut.centerAddText;
                                    }
                                    ctx.fillText(text, centerX, textY);
                                }
                            }
                        }
                    } else if(conf.type === "treemap"){
                        this.data.datasets.forEach(function (dataset, i) {
                            let meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {
                                let data = dataset.data[bar._index].v.toString();
                                let x = bar._model.x;
                                let y = bar._model.y - (bar._model.height / 2) + (Chart.defaults.global.defaultFontSize * 2);
                                ctx.fillStyle = dataset.showValue.textColor;
                                ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                            });
                        });
                    } else {
                        let totalSum = 0;
                        var datasetCount = this.data.datasets.length;
                        var dataValues = [];
                        let animationLabels = this.data.labels;

                        // start: 퍼센트 표기 추가 - 데이터셋 전체
//                        this.data.datasets.forEach(function (dataset, i) {
//                        	if(typeof dataset.showValuePercentSum !== 'undefined' && dataset.showValuePercentSum){
//	                        	dataset.data.forEach(function(ddd){
//	                        		totalSum += Number(ddd);
//	                        	});
//                        	}
//                        });
                        // end: 퍼센트 표기 추가

                        this.data.datasets.forEach(function (dataset, i) {
                            // start: 퍼센트 표기 추가 - 데이터셋 별
//                        	let total = 0;
//                        	if(typeof dataset.showValuePercent !== 'undefined' && dataset.showValuePercent){
//                            	dataset.data.forEach(function(ddd){
//                            		total += Number(ddd);
//                            	});
//                        	}
                            // end: 퍼센트 표기 추가

                            animationColors.forEach(function(color){
                                if(dataset.dataKdHdngSqno == color.key) {
                                    ctx.fillStyle = color.value;

                                    var meta = chartInstance.controller.getDatasetMeta(i);
                                    meta.data.forEach(function (bar, index) {
                                        var data = dataset.data[index].toString();
                                        // 좌우 표출일 경우, 음수 값을 양수로 변환
                                        if (conf.type === "horizontalBar" && typeof conf.isSideDisplay !== 'undefined' && conf.isSideDisplay) {
                                            data = Math.abs(data); // 음수 값을 양수로 변환
                                        }
                                        var x = bar._model.x;
                                        var y = bar._model.y;

                                        if(conf.type == "bar" || conf.type == "line" || conf.type == "arrowBar") {
                                            y = y - 5;
                                            // 상하 반전차트의 경우 위치조절
                                            conf.options.scales.yAxes.forEach(function(yAxe){
                                                if(typeof yAxe.ticks.reverse !== 'undefined' && yAxe.ticks.reverse) {
                                                    if(yAxe.id == dataset.yAxisID) {
                                                        y = y + 20;
                                                    }
                                                }
                                            });
                                            if(conf.stacked == true && conf.stackedValue != true) {
                                                var centerPoint = bar.getCenterPoint();
                                                x = centerPoint.x;
                                                y = centerPoint.y;
                                                y = y + (Chart.defaults.global.defaultFontSize / 2);
                                            }
                                        } else if(conf.type == "horizontalBar") {
                                            x = x + 4;
                                            y = y + 5;
                                            if (displayMode == "did") {
                                                x = x + 4;
                                                y = y + 8;
                                            }

                                            // 좌우 반전차트의 경우 위치조절
                                            conf.options.scales.xAxes.forEach(function(xAxe){
                                                if(typeof xAxe.ticks.reverse !== 'undefined' && xAxe.ticks.reverse) {
                                                    if(xAxe.id == dataset.xAxisID) {
                                                        if(vm.viewScale === 3) {
                                                            x = x - (40 + data.length + (data.length * (3 * vm.viewScale)));
                                                        } else {
                                                            x = x - (18 + data.length + (data.length * 3));
                                                        }
                                                    }
                                                }
                                            });

                                            if(conf.stacked == true && conf.stackedValue != true) {
                                                var centerPoint = bar.getCenterPoint();
                                                x = centerPoint.x;
                                                y = centerPoint.y+6;
                                                if (displayMode == "did") {
                                                    x = centerPoint.x;
                                                    y = centerPoint.y+13;
                                                }
                                            }
                                        }

                                        // 라인차트 값 상하단 표기
                                        if(typeof dataset.valuePosition !== 'undefined') {
                                            if(dataset.type === 'line' && dataset.valuePosition === 'bottom') {
                                                if(displayMode == "did") {
                                                    y = y + 40;
                                                } else {
                                                    y = y + 22;
                                                }
                                            }
                                        }

                                        if(Number(data) < 0) {
                                            if(dataset.type === 'bar' || dataset.type === 'arrowBar') {
                                                if(displayMode == "did") {
                                                    y = y + 38;
                                                } else {
                                                    y = y + 20;
                                                }
                                            }
                                        }

                                        // 값 병합 추가
                                        if(conf.stacked == true && conf.stackedValue == true
                                            && (dataset.type == 'bar' || dataset.type == 'horizontalBar' || dataset.type == 'arrowBar')) {
                                            if(data == "") {
                                                data = 0;
                                            }
                                            if(typeof dataValues[index] == 'undefined') {
                                                dataValues[index] = 0;
                                            }
                                            dataValues[index] += parseFloat(data);
                                            if(i == datasetCount - 1) {
                                                var val = parseFloat(dataValues[index]);
                                                var digitFixed = dataset.digitFixed;
                                                if(typeof digitFixed !== 'undefined') {
                                                    if(parseInt(digitFixed) < 0) {
                                                        // 절사
                                                        val = Math.floor(parseFloat(val) / (parseInt(digitFixed) * -1));
                                                    } else {
                                                        // 소수처리
                                                        val = parseFloat(val).toFixed(digitFixed);
                                                    }
                                                }
                                                var dataVal = val.toString();
                                                ctx.fillText(dataVal.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                            }
                                        } else {
                                            // 값 병합 아니여도 합산 표기(좌우표출 제외)
                                            if(conf.stacked == true && conf.stackedValue == false
                                                && (dataset.type == 'bar' || dataset.type == 'horizontalBar' || dataset.type == 'arrowBar')
                                                && (typeof conf.isSideDisplay == 'undefined' || !conf.isSideDisplay) ) {
                                                if(data == "") {
                                                    data = 0;
                                                }
                                                if(typeof dataValues[index] == 'undefined') {
                                                    dataValues[index] = 0;
                                                }
                                                dataValues[index] += parseFloat(data);
                                                if(i == datasetCount - 1) {
                                                    var val = parseFloat(dataValues[index]);
                                                    var digitFixed = dataset.digitFixed;
                                                    if(typeof digitFixed !== 'undefined') {
                                                        if(parseInt(digitFixed) < 0) {
                                                            // 절사
                                                            val = Math.floor(parseFloat(val) / (parseInt(digitFixed) * -1));
                                                        } else {
                                                            // 소수처리
                                                            val = parseFloat(val).toFixed(digitFixed);
                                                        }
                                                    }
                                                    var dataVal = val.toString();
                                                    // 합산 값 폰트 위치 / 사이즈 조절
                                                    let modelX = bar._model.x;
                                                    let modelY = bar._model.y;
                                                    if(typeof conf.stackedValueBold !== 'undefined' && conf.stackedValueBold) {
                                                        modelY = bar._model.y - ( 1 * vm.viewScale);
                                                        let size = Chart.defaults.global.defaultFontSize + (2 * $_WC.viewScale);
                                                        ctx.font = Chart.helpers.fontString(size, 'bold', Chart.defaults.global.defaultFontFamily);
                                                    }
                                                    ctx.fillText(dataVal.replace(/\B(?=(\d{3})+(?!\d))/g, ","), modelX, modelY);
                                                }
                                                if(typeof conf.stackedValueBold !== 'undefined' && conf.stackedValueBold) {
                                                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                                                }
                                            }
                                            if(data != "") {
                                                var val = parseFloat(data);
                                                data = val.toString();

                                                // start: 퍼센트 표기 추가
//                                                if(typeof dataset.showValuePercent !== 'undefined' && dataset.showValuePercent){
////                                                	if(typeof dataset.showValuePercentSum !== 'undefined' && dataset.showValuePercentSum){
////                                                		let percentSum = String(Math.round( Number(data) / totalSum * 100)) + "%";
////                                                		if(typeof dataset.showValueVal !== 'undefined' && !dataset.showValueVal){
////                                                			data = percentSum;
////                                                		} else {
////                                                			data += ' (' + percentSum + ')';
////                                                		}
////                                                	} else {
//                                                		let percent = String(Math.round( Number(data) / total * 100)) + "%";
////                                                		if(typeof dataset.showValueVal !== 'undefined' && !dataset.showValueVal){
////                                                			data = percent;
////                                                		} else {
//                                                			data += ' (' + percent + ')';
//                                                		}
////                                                	}
//                                                }
                                                // end: 퍼센트 표기 추가
                                            }

                                            if(typeof dataset.showValueRemove !== 'undefined' && Number(dataset.showValueRemove) > 0
                                                && Number(data) < Number(dataset.showValueRemove)) {
                                            } else {
                                                // 값 표기 방식 추가
                                                if (typeof dataset.showValueType === 'undefined' || dataset.showValueType == '') {
                                                    ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                } else {
                                                    // 최초 or 최종 값만 표기
                                                    if (dataset.showValueType === 'first') {
                                                        if (index == 0) {
                                                            ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                        }
                                                    } else if (dataset.showValueType === 'last') {
                                                        if (index == meta.data.length - 1) {
                                                            ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                        }
                                                    } else if (dataset.showValueType === 'text') {
                                                        let labelSeq;
                                                        animationLabels.forEach(function (d, i) {
                                                            if (d === dataset.showValueText) {
                                                                labelSeq = i;
                                                            }
                                                        });
                                                        if (typeof labelSeq !== 'undefined') {
                                                            if (index === labelSeq) {
                                                                ctx.fillText(data.replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                        });
                    }
                    if(typeof vm.$eventBus !== 'undefined') {
                        if(!vm.isAnimationOnComplete) {
                            vm.$eventBus.$emit('GripChart:animation-onComplete', vm.chartid);
                        }
                        vm.isAnimationOnComplete = true;
                    }
                };
            } // if(animationColors.length > 0) {

            // 애니메이션 동작 수정 (값 표기 없는 경우 동작하지 못하는 오류 수정)
            if(typeof conf.options.animation !== 'undefined') {
                if(typeof conf.options.animation.easing !== 'undefined') {
                    animation.easing = conf.options.animation.easing;
                }
                if(typeof conf.options.animation.duration !== 'undefined') {
                    animation.duration = conf.options.animation.duration * 1000;
                } else {
                    animation.duration = 1000;
                }
            } else {
                animation.duration = 1000;
            }
            conf.options.animation = animation;
            if(typeof conf.options.hover !== 'undefined'){
                conf.options.hover.animationDuration = 0;
            }

            // click event 추가
            conf.options.onClick = function(event, item){
                if(typeof vm.$parent.clickChartListener === 'function') {
                    if(item.length == 1) {
                        let datasetIndex = item[0]._datasetIndex;
                        let index = item[0]._index;

                        let label = this.data.labels[index];
                        let data = this.data.datasets[datasetIndex].data[index];
                        let datasetLabel = this.data.datasets[datasetIndex].label;

                        if(Array.isArray(datasetLabel)) {
                            datasetLabel = datasetLabel[index];
                        }
                        vm.$parent.clickChartListener(
                            this.config.dataKdSqno, vm.chartid, label, data, datasetLabel, item[0]);
                    }
                }
            };

            // start: 라인차트를 앞으로 (처리하지 않으면 막대랑 라인 동시에 사용하는 경우 뒤로 깔림)
            if(conf.type == "bar" || conf.type == "line" || conf.type == 'arrowBar') {
                var newDatasets = [];
                conf.data.datasets.forEach(function(dataset) {
                    if(dataset.type == "") {
                        dataset.type = conf.data.datasets[0].type;
                    }
                    if(dataset.type == "line") {
                        newDatasets.push(dataset);
                    }
                });
                conf.data.datasets.forEach(function(dataset) {
                    if(dataset.type == "bar" || dataset.type == "arrowBar") {
                        newDatasets.push(dataset);
                    }
                });
                conf.data.datasets = newDatasets;
            }
            // end: 라인차트를 앞으로 (처리하지 않으면 막대랑 라인 동시에 사용하는 경우 뒤로 깔림)

            var legendCallback = function(chart) {
                return vm.drawCustomLegend(chart);
            }
            conf.options.legendCallback = legendCallback;
        },
        drawCustomLegend: function(chart) {
            let chartType = chart.config.type;
            var text = [];
            for (let i = 0; i < chart.data.datasets.length; i++) {
                var dataset = chart.data.datasets[i];
                if(typeof dataset.hidden !== 'undefined' && dataset.hidden === true) {
                    continue;
                }
                let label = '';
                if(Array.isArray(dataset.label)) {
                    for (let j = 0; j < dataset.label.length; j++) {
                        let backgroundColor = dataset.borderColor[j];
                        if(chartType === 'treemap'){
                            backgroundColor = dataset.hoverBackgroundColor[j];
                        }
                        label = dataset.label[j].trim();
                        if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                            && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                            label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                            if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                                label += '' + chart.options.legendFormatAdd;
                            }
                        }
                        if(typeof chart.options.showValueLegend !== 'undefined' && chart.options.showValueLegend === true) {
                            text.push("<span><i style=\"background:" + backgroundColor + "\"></i>" + label  + " (" + dataset.data[j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ")</span>");
                        } else {
                            text.push("<span><i style=\"background:" + backgroundColor + "\"></i>" + label  + "</span>");
                        }
                    }
                } else {
                    let backgroundColor = dataset.borderColor;
                    if(chartType === 'treemap'){
                        backgroundColor = dataset.hoverBackgroundColor;
                    }
                    if(typeof dataset.label === 'string'){
                        label = dataset.label.trim();
                    }
                    if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                        && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                        label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                        if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                            label += '' + chart.options.legendFormatAdd;
                        }
                    }
                    // 특정 바의 색상을 변경한경우 범례는 default color 를 사용한다.
                    if(typeof dataset.defaultColor !== 'undefined') {
                        text.push("<span><i style=\"background:" + dataset.defaultColor + "\"></i>" + label + "</span>");
                    } else {
                        text.push("<span><i style=\"background:" + backgroundColor + "\"></i>" + label + "</span>");
                    }
                }
                if(typeof dataset.replaceColorType !== 'undefined') {
                    if(typeof dataset.label === 'string'){
                        label = dataset.label.trim();
                    }
                    if(typeof chart.options.legendFormatSt !== 'undefined' && typeof chart.options.legendFormatEd !== 'undefined'
                        && chart.options.legendFormatSt !== '' && chart.options.legendFormatEd !== ''){
                        label = label.substring(chart.options.legendFormatSt, chart.options.legendFormatEd).trim();
                        if(typeof chart.options.legendFormatAdd !== 'undefined' && chart.options.legendFormatAdd !== ''){
                            label += '' + chart.options.legendFormatAdd;
                        }
                    }
                    if(dataset.replaceColorType === 'over' || dataset.replaceColorType === 'down') {
                        let addText = (dataset.replaceColorType === 'over') ? '이상' : '이하';
                        text.push("<span><i style=\"background:" + dataset.replaceColor + "\"></i>" + dataset.replaceColorValue + addText + " " + label + "</span>");
                    } else if(dataset.replaceColorType === 'max' || dataset.replaceColorType === 'min') {
                        // 최고 / 최소의 경우 범례를 추가하지 않는다.
                        // text.push("<span><i style=\"background:" +
                        // dataset.replaceColor + "\"></i>" + dataset.label +
                        // "</span>");
                    } else if(dataset.replaceColorType === 'equal') {
                        text.push("<span><i style=\"background:" + dataset.replaceColor + "\"></i> " + dataset.replaceColorValue + " " + label + "</span>");
                    }
                }
            }
            return text.join("");
        },
        logest: function(xrange, yrange) {
            let x_avg = xrange.reduce(function(a, b) { return a + b; }) / xrange.length;
            let y_avg = yrange.reduce(function(a, b) { return  a + b; }) / yrange.length;

            let numerator = xrange.reduce(function(a, b, i) { return a + (Math.log(b) - Math.log(x_avg)) * (yrange[i] - y_avg); }, 0);
            let denominator = xrange.reduce(function(a, b) { return a + Math.pow(Math.log(b) - Math.log(x_avg), 2); }, 0);

            let b = numerator / denominator;
            let a = y_avg - b * Math.log(x_avg);

            return [b, a];
        },
        // scales를 사용 못 하는 차트의 경우 기준데이터 변환 기능 - rader, treemap
        setNonScalesLabels: function(conf){
            let vm = this;
            conf.data.labels.forEach(function(label, i){
                conf.data.labels[i] = vm.setStandardVal(conf, label);
            });
        },
        // 기준값 변환
        setStandardVal: function(conf, value){
            if(typeof conf.options.formatter !== 'undefined') {
                if(conf.options.formatter.length > 0) {
                    let newValue = "";
                    conf.options.formatter.forEach(function(formatter){
                        if(!isNaN(formatter.start) && !isNaN(formatter.end)) {
                            let reVal = value.substring(formatter.start, formatter.end);
                            if(reVal !== '') {
                                if (newValue != "") {
                                    // 자간 삭제기능 추가
                                    if (typeof conf.options.formatTrim === 'undefined' || conf.options.formatTrim === false) {
                                        newValue += " ";
                                    }
                                }
                                newValue += reVal + formatter.addText;
                            }
                        }
                    });
                    if(newValue != "") {
                        value = newValue;
                    }
                }
            }

            // 추출
            if(typeof conf.options.extract !== 'undefined' && conf.options.extract.gubun !== '' && conf.options.extract.number > 0) {
                let tmpValue = value.split(conf.options.extract.gubun);
                if(typeof tmpValue[conf.options.extract.number - 1] !== 'undefined'){
                    value = tmpValue[conf.options.extract.number - 1];
                }
            }
            return value;
        },
        setDatasets: function(dataset, datas){
            if(typeof dataset.zeroToNull !== 'undefined' && dataset.zeroToNull){
                let newDatas = [];
                datas.forEach(function(d){
                    if(d !== '' && Number(d) !== 0){
                        newDatas.push(d);
                    }
                });
                datas = newDatas;
            }
            return datas;
        },
        setDatasetsMinus: function(dataset, datas) {
            let newDatas = [];
            if(typeof dataset.zeroToNull !== 'undefined' && dataset.zeroToNull){
                datas.forEach(function(d){
                    if(d !== '' && Number(d) !== 0){
                        let dt = -Number(d);
                        newDatas.push(String(dt));
                    }
                });
                datas = newDatas;
            } else {
                datas.forEach(function(data){
                    if(isNaN(Number(data))) {
                        data = '0';
                    }
                    let dt = -Number(data);
                    newDatas.push(String(dt));
                });
                datas = newDatas;
            }
            return datas;
        },
    }
}
</script>
